import { styled } from '@mui/material';
import { rem } from 'polished';
import { FieldCounter } from '../template-head/template-head.styled';

export const MessageFieldCounter = styled(FieldCounter)({
  marginTop: rem(5),
});
